module.exports = __webpack_public_path__ + "img/icon_ecommerce.090d1b6d.png";